/*
 * @Author: ken yang
 * @Date: 2022-10-31 14:29:45
 * @LastEditTime: 2023-09-06 16:33:09
 * @LastEditors: ken yang
 * @Description: 接口入口文件
 * @FilePath: /uexch_admin/src/api/index.js
 */
import futuresApi from './futures.js'
import userApi from './user.js'
import dataApi from './data.js'
import commissionsApi from './commissions.js'
import agentApi from './agent.js'
import withdrawMoneyApi from './withdrawMoney.js'

const delay = date => new Promise((resolve, reject) => { // 延迟
  setTimeout(() => resolve(), date || 2000)
})

const needLoginUrl = []

export {
  futuresApi,
  userApi,
  dataApi,
  commissionsApi,
  agentApi,
  withdrawMoneyApi,
  needLoginUrl,
  delay,
}
